/**
 * Bayi oturumundan bağımsız, son kullanıcıya (kart hamiline) açık sayfalar.
 *
 * Bu sayfalarda App açılışındaki oturumlu yüklemeler (sepet, favori, kullanıcı) ve ChatWidget
 * çalışmaz. Sebep: bağlantı çoğu zaman bayinin kendi telefonunda açılır; telefondaki tarayıcıda
 * eskimiş bir bayi oturumu varsa bu çağrılar 401 alır, proxy kullanıcıyı giriş sayfasına atar ve
 * orada yapılan yeni giriş, web'de kullanıcı başına tek oturum olduğu için bayinin bilgisayarda
 * açık duran ödeme ekranını düşürür. Doğrulama kodu da bu yüzden hiç girilemez (05.10.2026 vakası).
 */
export const isPublicCustomerPath = (pathname: string): boolean => pathname.startsWith('/kart-onay/')
